import s from './DisplayEditSettings.module.css';
import { useSelector } from 'react-redux';
import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import ImageWizardBlock from '../promt-blocks/ImageWizardBlock';
import RefineTextBlock from '../promt-blocks/RefineTextBlock';
import ReferencesBlock from '../promt-blocks/ReferencesBlock';
import TextOptionsBlock from '../promt-blocks/TextOptionsBlock';
import ToneAndVoiceBlock from '../promt-blocks/ToneAndVoiceBlock';

import ChooseSocialMediaBlock from '../promt-blocks/ChooseSocialMediaBlock';
import EffectsAdjust from '../effects-adjust/EffectsAdjust';
import ColorAdjust from '../color-adjust/ColorAdjust';
import AddTextBlock from '../../../image-editor-page/widgets/prompt-blocks/AddTextBlock';
import CreatePostBlock from '../promt-blocks/CreatePostBlock';

const tabMap: Record<string, JSX.Element> = {
    image_wizard: <ImageWizardBlock />,
    tone_and_voice: <ToneAndVoiceBlock />,
    refine_text: <RefineTextBlock />,
    references: <ReferencesBlock />,
    text_options: <TextOptionsBlock />,
    preview_post: <ChooseSocialMediaBlock />,
    effects: <EffectsAdjust />,
    adjust_colors: <ColorAdjust />,
    add_text: <AddTextBlock />,
    create_post: <CreatePostBlock />,
};
const DisplayEditSettings = () => {
    const activePrompt = useSelector(selectActivePrompt);

    if (!activePrompt) return null;
    return (
        <div key={activePrompt} className={s.container}>
            {activePrompt ? tabMap[activePrompt] : null}
        </div>
    );
};

export default DisplayEditSettings;
